import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { GetdatafirebaseService } from './../../services/getdatafirebase.service';
import { UpdatefirebaseService } from './../../services/updatefirebase.service';
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-editplantinfo-manager',
  templateUrl: './editplantinfo-manager.component.html',
  styleUrls: ['./editplantinfo-manager.component.css']
})
export class EditplantinfoManagerComponent implements OnInit {

  userdata: any;
  Comment: UntypedFormGroup;
  time: any;
  userlevel: string
  editter = false;
  constructor(
    private auth: Authenticationservice,
    private firebase: UpdatefirebaseService,
    private getdata: GetdatafirebaseService,
    private router: Router
  ) {
    let userdata: any = this.auth.Authention();
    this.userdata = userdata
    this.Comment = new UntypedFormGroup({
      commentfinace: new UntypedFormControl()
    });
    let userlv = userdata.userlevel;
    if (userlv == 12 || userlv == 10 || userlv == 14 || userlv == 15) {
      this.editter = true;
      const date = new Date()
      const result = date.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        //  hour: '2-digit',
        //  minute: '2-digit',
        //  second: '2-digit',
      })
      this.time = result;
    }
    else {
      this.router.navigateByUrl('/loign');
    }
  };

  @ViewChild('listplantedit') listplantedit: ElementRef;

  ngOnInit(): void {
    let userlv = this.userdata.userlevel
    if (userlv == '12' || userlv == '14') {
      this.Loadlistformanager();
    }
    else {
      this.LoadlistAsk();
    }
  }

  zonelist: any[] = [];
  LoadlistAsk() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_editDataCP_w?edit_status=0&Partcode=" + this.userdata.zonedata;
    axios.get(url)
      .then(res => {
        this.zonelist = res.data.recordset;
        // console.log('data ',this.zonelist);

        setTimeout(() => {
          $(this.listplantedit.nativeElement).DataTable();
        }, 2500);
      })
      .catch(err => { throw (err) })
  }

  acpzonelist: any;
  Loadlistformanager() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_editDataCP_w?edit_status=4";
    axios.get(url)
      .then(res => {
        this.acpzonelist = res.data.recordset;
        setTimeout(() => {
          $(this.listplantedit.nativeElement).DataTable();
        }, 2500);
      })
      .catch(err => { throw (err) })
  }

  Accept(id: any, type: any) {

    let data = this.acpzonelist.filter((el: any) => el.edit_ID == id);
    if (confirm("ต้องการแก้ไขข้อมูลนี้ใช่หรือไม่ ?") == true) {
      if (type == 1) // ยกเลิกแปลง
      {
        this.firebase.updatePlantStatus(data[0].year, data[0].itid, 3);
        this.LoadlistAsk();
      }
      else if (type == 2) // แก้ไขประเภทอ้อย
      {
        this.firebase.updateCaneType(data[0].year, data[0].itid, data[0].edit_code_to, data[0].edit_to);
        this.LoadlistAsk();
      }
      else if (type == 3) // แก้ไขเจ้าของแปลง
      {
        alert("ยังไม่พร้อมใช้งานค่ะ!");
      }
      else if (type == 4) // แก้ไขโซน
      {
        let lastnumber: any;
        this.getdata.getPlantnobyfmcode(data[0].fmcode).then((res: any) => {
          lastnumber = res[0];
        });
        setTimeout(() => {
          let number = parseInt(lastnumber.number) + 1;
          let landno = data[0].fmcode + "-" + String(data[0].fmcode) + "-" + (data[0].landno).slice(14, 18);
          let newlandno = data[0].fmcode + "-" + String(data[0].fmcode) + "-000" + String(number);

          this.getdata.Checkplantnobyzone(landno).then((res: any) => {
            if (res.length == 0) {
              this.firebase.updateZoneplant(data[0].year, data[0].itid, data[0].edit_code_to, landno);
            }
            else {
              this.firebase.updateplantnowithfmcode(lastnumber.key, number);
              this.firebase.updateZoneplant(data[0].year, data[0].itid, data[0].edit_code_to, newlandno);
              // this.firebase.updatezoneplantno(data[0].itid,newlandno);
            }
          });
        }, 1500);
      }
      else if (type == 5) // กรรมสิทธิ์
      {
        this.firebase.updatePlantSelfLand(data[0].year, data[0].itid, data[0].edit_to)
        this.LoadlistAsk();
        // 1 เช่า 2 ตนเอง
      }
      else if (type == 6) // แก้ไขนักส่งเสริม ผู้ดูแลแปลง
      {
        this.firebase.updateSupporter(data[0].year, data[0].itid, data[0].edit_code_to)
        setTimeout(() => {
          this.Loadlistformanager();
        }, 4500);
      }
    }
    else { }
  }


  // ผอ อัพเดท
  managerUpdate(id: any, type: any) {
    let comment = this.Comment.get('commentfinace').value;
    let url = "";
    if (type == 1) {
      if (confirm('ยืนยันการอนุมัติ') == true) {
        url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_editDataCP_w?edit_ID=" + id + "&edit_status=1&comment3='" + comment + "'&date_act=getdate()";
        axios.post(url).then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert('อนุมัติและแก้ไขแล้ว');
          }
          else {
            alert('!!!! ทำรายการไม่สำเร็จแล้ว กรุณาลองใหม่ !!!!');
          }
        }).catch(err => { throw err })
        this.Accept(id, this.oneselect[0].edit_type);
        this.closemodel();
      }
      else { }
    }
    else if (type == 2) {
      url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_editDataCP_w?edit_ID=" + id + "&edit_status=5&comment3='" + comment + "'&date_act2=getdate()";
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert('ทำรายการสำเร็จแล้ว');
        }
        else {
          alert('!!!! ทำรายการไม่สำเร็จแล้ว กรุณาลองใหม่ !!!!');
        }
      }).catch(err => { throw err })
      this.closemodel();
      this.Loadlistformanager();
    }

    else {
      url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_editDataCP_w?edit_ID=" + id + "&edit_status=6&comment3='ผอ. อนุมัติแล้วรอดำเนินการ'&date_act2=getdate()";
    }

  }

  // สินเชื่ออนุมัติ
  FinanceAccept(id: any) {
    if (confirm('ยืนยันการอนุมัติ') == true) {
      let comment = this.Comment.get('commentfinace').value;
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_editDataCP_w?edit_ID=" + id + "&edit_status=4&comment2='" + comment + "'&date_act=getdate()";
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert('ทำรายการสำเร็จแล้ว');
        }
        else {
          alert('!!!! ทำรายการไม่สำเร็จแล้ว กรุณาลองใหม่ !!!!');
        }
      }).catch(err => { throw err })
      this.closemodel();
      this.LoadlistAsk();
    }
    else {

    }

  }

  // สินเชื่อไม่อนุมัติ
  FinanceUnAccept(id: any) {
    if (confirm('ยืนยันไม่อนุมัติ') == true) {
      let comment = this.Comment.get('commentfinace').value;
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_editDataCP_w?edit_ID=" + id + "&edit_status=3&comment2='" + comment + "'&date_act=getdate()";
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert('ทำรายการสำเร็จแล้ว');
        }
        else {
          alert('!!!! ทำรายการไม่สำเร็จแล้ว กรุณาลองใหม่ !!!!');
        }
      }).catch(err => { throw err })
    }
    else {

    }
    this.closemodel();
    this.LoadlistAsk();
  }

  oneselect: any;
  titletext: any;
  openmodel(id: any) {
    this.titletext = "ตรวจสอบสินเชื่อแปลง";
    $("#explan_plant").modal('show');
    this.oneselect = this.zonelist.filter(el => el.edit_ID === id);
    console.log(this.oneselect);

  }

  openmodelmanager(id: any) {
    this.titletext = "ข้อมูแปลง ผ่านสินเชื่อแล้ว"
    $("#explan_plant").modal('show');
    this.oneselect = this.acpzonelist.filter(el => el.edit_ID == id);
  }

  closemodel() {
    $("#explan_plant").modal('hide');
  }

  // พิมพ์ฟอร์มขอแก้ไข
  datatoPrint: any;
  printForm(id: any) {
    // console.log('ข้อมูลขอแก้ไข ',this.zonelist);
    // $("#md_printForm").modal('show');
    this.datatoPrint = this.zonelist.filter(el => el.edit_ID === id);
    // console.log('data to print ',this.datatoPrint);
    const printContent: any = document.getElementById("formPrint");
    const WindowPrt: any = window.open('', '', 'left=100,top=100,width=900,height=500,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  };

  printDiv(divName) {
    var printContents = document.getElementById(divName).innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.titletext = null;
    this.acpzonelist = null;
    this.zonelist = null;
    this.datatoPrint = null;
  }

}

